import iconFb from './facebook.webp';
import yutbur from './youtube-1.webp';
import yutbur2 from './youtube.webp';
import linkedin from './linkedin.webp';

export const socialLinks = [
  { title: 'Facebook', href: 'https://www.facebook.com/EcosenseArmenia/', icon: iconFb },
  { title: 'Instagram', href: 'https://www.instagram.com/ecosense_armenia/', icon: yutbur },
  { title: 'YouTube', href: 'https://www.youtube.com/@Dr.PodCast_EcoSense', icon: yutbur2 },
  { title: 'Linkedin', href: 'https://www.linkedin.com/in/ecosensearmenia/', icon: linkedin },
];
